var _circle, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgChartIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 38,
    height: 38,
    viewBox: "0 0 38 38",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 19,
    cy: 19,
    r: 18.5,
    stroke: "#E2ECFF"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14 24H18C18.2833 24 18.521 23.904 18.713 23.712C18.9043 23.5207 19 23.2833 19 23C19 22.7167 18.9043 22.479 18.713 22.287C18.521 22.0957 18.2833 22 18 22H14C13.7167 22 13.479 22.0957 13.287 22.287C13.0957 22.479 13 22.7167 13 23C13 23.2833 13.0957 23.5207 13.287 23.712C13.479 23.904 13.7167 24 14 24ZM20 16H24C24.2833 16 24.5207 15.904 24.712 15.712C24.904 15.5207 25 15.2833 25 15C25 14.7167 24.904 14.479 24.712 14.287C24.5207 14.0957 24.2833 14 24 14H20C19.7167 14 19.4793 14.0957 19.288 14.287C19.096 14.479 19 14.7167 19 15C19 15.2833 19.096 15.5207 19.288 15.712C19.4793 15.904 19.7167 16 20 16ZM17 20H21C21.2833 20 21.521 19.904 21.713 19.712C21.9043 19.5207 22 19.2833 22 19C22 18.7167 21.9043 18.479 21.713 18.287C21.521 18.0957 21.2833 18 21 18H17C16.7167 18 16.4793 18.0957 16.288 18.287C16.096 18.479 16 18.7167 16 19C16 19.2833 16.096 19.5207 16.288 19.712C16.4793 19.904 16.7167 20 17 20ZM12 28C11.45 28 10.979 27.8043 10.587 27.413C10.1957 27.021 10 26.55 10 26V12C10 11.45 10.1957 10.979 10.587 10.587C10.979 10.1957 11.45 10 12 10H26C26.55 10 27.021 10.1957 27.413 10.587C27.8043 10.979 28 11.45 28 12V26C28 26.55 27.8043 27.021 27.413 27.413C27.021 27.8043 26.55 28 26 28H12ZM12 26H26V12H12V26ZM12 26V12V26Z",
    fill: "#5B5B5B"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChartIcon);
export default __webpack_public_path__ + "static/media/chartIcon.f992d405798233f6647fcd2eed80a366.svg";
export { ForwardRef as ReactComponent };